import React from 'react'
import PropTypes from 'prop-types'
import {Flex, useStyleConfig} from '@chakra-ui/react'
import ReactCountryFlag from 'react-country-flag'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const CountryFlag = ({countryCode}) => {
    const styles = useStyleConfig('CountrySelectorFooter')
    if (!countryCode) return null

    return (
        <Flex {...styles.countrySvgContainer} flexShrink={0} aria-hidden="true">
            <ReactCountryFlag
                countryCode={countryCode}
                svg
                cdnUrl={getAssetUrl('static/img/flags/4x3/')}
                cdnSuffix="svg"
                alt=""
                style={{
                    width: 'auto',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                }}
            />
        </Flex>
    )
}

CountryFlag.propTypes = {
    countryCode: PropTypes.string,
}

export default CountryFlag
